export default __webpack_public_path__ + "static/media/frame-1.36acbe71.png";